import React from 'react';
import { Backdrop, CircularProgress, createStyles, Theme, WithStyles, withStyles } from "@material-ui/core";

const styles = ( ({ zIndex }: Theme) =>
  createStyles({
    parent: {
        position: "relative",
        height: '100vh',
        zIndex: 0,
        padding: 0,
      },
    backdrop: {
      zIndex: zIndex.drawer + 1,
      color: '#fff',
      position: 'absolute',
    },
  })
);

class LoadingBackdrop extends React.Component<WithStyles<typeof styles>> {
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.parent}>
                <Backdrop className={classes.backdrop} open>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        )
    }
}

export default withStyles(styles)(LoadingBackdrop);